// Version utility copied from nova
// Not ideal to copy it, but the nova version has some stuff that will only work on the server

const isString = require("lodash/isString");
const has = require("lodash/has");
const isNumber = require("lodash/isNumber");
const log = console;

var SpecialSuffixes = {
    autosave: 'autosave',
    // add other special version strings here
};

// Convert a version string into a Version object
function parseVersion(version) {
    if(version && version instanceof Version) {
        return version;
    }

    if(!isString(version)) {
        console.error("parseVersion: Passed in version '" + version + "' is not a string or a Version object.");
        return null;
    }

    var parts = version.split(".");
    if(parts.length < 3) {
        console.error("parseVersion: Version string '" + version + "' has less than 3 parts.");
        return null;
    }

    for(var i = 0; i < 3; ++i) {
        if(!parts[i].match(/^\d+$/)) {
            console.error("parseVersion: Found non-integer part at index " + i);
            return null;
        }
    }

    var major = parseInt(parts[0], 10);
    var minor = parseInt(parts[1], 10);
    var patch = parseInt(parts[2], 10);
    
    if(parts.length > 3) {
        var special = parts[3];
        if (parts.length > 4) {
            console.warn("parseVersion: version had more than 4 parts. Only the first 4 will be used.");
        }
        if (!SpecialSuffixes[special]) {
            console.warn("parseVersion: part 4 '" + special + "' is not a known special suffix.");
        }
        return new Version(major, minor, patch, special);
    }

    return new Version(major, minor, patch);
}

function makeAutosaveVersion(version) {
    if(!version) {
        console.error("makeAutosaveVersion missing version.");
        return null;
    }
    if (!(version instanceof Version)) {
        version = parseVersion(version);
    }
    return version.setField("special",SpecialSuffixes.autosave).toString();
}

function Version(major, minor, patch, special) {
    // Note: these exact fields are used in the compare function
    this.major = major; // integer
    this.minor = minor; // integer
    this.patch = patch; // integer
    this.special = special; // string or undefined
}

Version.prototype.isOrdinaryVersion = function() {
    if (typeof this.special === 'undefined') {
        return true;
    }
    return false;
};

Version.prototype.isAutosave = function() {
    return this.special === SpecialSuffixes.autosave;
};

Version.prototype.toString = function() {
    if (typeof this.special === 'undefined') {
        return this.major + "." + this.minor + "." + this.patch;
    }
    return this.major + "." + this.minor + "." + this.patch;
}

// Return 1 if this > other
// Return 0 if equivalent
// Return -1 if this < other
Version.prototype.compare = function(version) {
    var other = parseVersion(version);
    if(!other) {
        log.error("Version.compare: Could not parse other version: " + version);
        return 1;
    }
    
    var keys = ['major','minor','patch']; // _.keys(this);

    var compareResult = 0;
    for(var i = 0; i < keys.length; ++i) {
        if(this[keys[i]] > other[keys[i]]) {
            compareResult = 1;
            break;
        }

        if(this[keys[i]] < other[keys[i]]) {
            compareResult = -1;
            break;
        }
    }

    if (compareResult !== 0) {
        return compareResult; // versions were different
    }
    
    var ordinary = this.isOrdinaryVersion();
    var otherOrdinary = other.isOrdinaryVersion();
    if (ordinary && otherOrdinary) {
        return compareResult;
    }
    
    if (ordinary) {
        return -1; // special versions are sorted before ordinary versions so they are never the 'latest' version
    }
    if (otherOrdinary) {
        return 1; // special versions are sorted before ordinary versions so they are never the 'latest' version
    }
    // both special. do a standard string ordering
    return this.special.localeCompare(other.special);
}

Version.prototype.bump = function(field) {
    if(!has(this, field)) {
        console.error("Version.bump: Version does not have field " + field);
        return this;
    }
    if (field === 'special') {
        log.error("Version.bump: Cannot bump special suffix");
        return this;
    }
    if (!this.isOrdinaryVersion()) {
        log.error("Version.bump: Special version cannot be bumped.");
        return this;
    }

    this[field] += 1;
    return this;
}

Version.prototype.setField = function(field, value) {
    if(!has(this, field)) {
        console.error("Version.setField: Version does not have field " + field);
        return this;
    }

    if (field === 'special') {
        if ( (typeof value === 'undefined') || (value === null) || (value === '') ) {
            delete this.special; // turn it into an ordinary version
        }
        else if (SpecialSuffixes[value]) {
            this[field] = value;
        }
        else {
            log.error("Version.setField: special suffix '" + value + "' not recognized. version unchanged.");
        }
        return this;
    }
    
    if(!isNumber(value) || value !== parseInt(value, 10)) {
        console.error("Version.setField: Did not pass in a valid integer value.");
        return this;
    }

    this[field] = value;
    return this;
}

module.exports = {
    parseVersion: parseVersion,
    makeAutosaveVersion: makeAutosaveVersion,
}
